import React, { useState, useEffect } from "react";
import axios from "axios";
import { Box, Button, TextField, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { Document, Page } from "react-pdf";
import { pdfjs } from "react-pdf";
import API_URL from "../../config";
import API_BASE_URL from "../../utils/api";

pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.mjs";

const TranscriptionBox = () => {
  const { documentId } = useParams();
  const [text, setText] = useState("");
  const [message, setMessage] = useState("");
  const [documentUrl, setDocumentUrl] = useState("");
  const [fileType, setFileType] = useState("");

  useEffect(() => {
    const fetchDocument = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/documents/${documentId}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });
        if (!res.data.fileUrl) {
          console.error("Error: File URL is missing in response");
          return;
        }

        const fileUrl = res.data.fileUrl.startsWith("http")
          ? res.data.fileUrl
          : `/api${res.data.fileUrl}`;

        setDocumentUrl(fileUrl);
        setFileType(fileUrl.split(".").pop().toLowerCase());
      } catch (err) {
        console.error("Error fetching document", err);
      }
    };
    fetchDocument();
  }, [documentId]);

  const handleSubmit = async () => {
    console.log("Submitting transcription for documentId:", documentId);
    if (!documentId) {
      console.error("Error: documentId is undefined");
      setMessage("Error: Document ID is missing.");
      return;
    }
    try {
      await axios.post(
        `${API_BASE_URL}/documents/${documentId}/transcribe`,
        { text },
        { withCredentials: true },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      setMessage("Transcription submitted for review!");
    } catch (err) {
      setMessage("Error submitting transcription.");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        gap: 3,
        padding: "20px",
        border: "1px solid #ccc",
        borderRadius: "5px",
      }}
    >
      <Box sx={{ flex: 1, maxWidth: "50%" }}>
        <Typography variant="h6">Document Preview</Typography>
        {fileType === "pdf" ? (
          <iframe
            src={documentUrl}
            width="100%"
            height="500px"
            style={{ border: "none" }}
            title="PDF Preview"
          ></iframe>
        ) : fileType === "jpg" || fileType === "jpeg" || fileType === "png" ? (
          <img
            src={documentUrl}
            alt="Uploaded Document"
            style={{ width: "100%", maxHeight: "400px", objectFit: "contain" }}
          />
        ) : (
          <Typography>No preview available</Typography>
        )}
      </Box>
      <Box sx={{ flex: 1, maxWidth: "50%" }}>
        <Typography variant="h5">Transcribe Document</Typography>
        <TextField
          label="Transcription"
          fullWidth
          multiline
          rows={10}
          value={text}
          onChange={(e) => setText(e.target.value)}
          sx={{ marginBottom: "10px" }}
        />
        <Button onClick={handleSubmit} variant="contained">
          Submit
        </Button>
        {message && <Typography>{message}</Typography>}
      </Box>
    </Box>
  );
};

export default TranscriptionBox;
